<script>
  import dialogMixin from "./mixins/dialog";

  export default {
    mixins: [dialogMixin],
    props: {
      text: {
        type: String,
        default: '促銷訊息',
        validator(value) {
          return [
            '促銷訊息',
            '品牌新訊',
          ].includes(value)
        },
      }
    },
    data() {
      return {}
    },
    computed: {

    },
    methods: {
      showLogin() {
        this.$emit('isShowlogin', true)
      }
    },
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogDealer } isStyleDealer`"
    width="876px"
    append-to-body
  >
    <div class="sectionTitle text-center font-medium color-gray-7">經銷商限定</div>
    <div class="text-base md:text-lg dialogDealer__content text-md-left text-center">
      <p>此{{ $route.params.categoryAlias === 'promotion' ? '促銷訊息' : '品牌新訊' }}為經銷商會員限定觀看</p>
      <p>若有疑問，請直接與我們聯繫</p>
    </div>
    <BaseButton
      class="isStylePrimary isRadius isFull mb-5"
      :to="{ name: 'inquiry' }"
    >
      聯絡我們
    </BaseButton>
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogDealer {
    // padding-right: 30px;
    // padding-left: 30px;
    :global {
    
    }
  }
</style>
